module.exports = __webpack_public_path__ + "img/package.3db385da.png";